import { useAsync, useMountEffect } from "@react-hookz/web";
import { fetchQuery, graphql, useRelayEnvironment } from "react-relay";

import { useCurrentPageType } from "shared/hooks";
import { PageType } from "shared/lib/page-type";

import type { iabCategoryAppConfigQuery } from "scmp-app/queries/__generated__/iabCategoryAppConfigQuery.graphql";

export const useIabCategory = () => {
  const currentPageType = useCurrentPageType();
  const environment = useRelayEnvironment();

  const [state, actions] = useAsync(async () => {
    const data = await fetchQuery<iabCategoryAppConfigQuery>(
      environment,
      graphql`
        query iabCategoryAppConfigQuery {
          appConfig(filter: { entityId: "scmp_iab_category" }) {
            json
          }
        }
      `,
      {},
      {
        fetchPolicy: "network-only",
      },
    ).toPromise();

    if (!data?.appConfig?.json) return;

    return data.appConfig.json as IabCategoryAppConfig;
  });

  useMountEffect(() => {
    if (currentPageType !== PageType.Article) return;
    void actions.execute();
  });

  return { iabCategoryAppConfigState: state.result };
};

type IabCategoryAppConfig = {
  [key: string]: string;
};
